import { useState, useEffect } from 'react'

interface BusinessItem {
  id: string
  name: string
  businessType: string
  stage: string
  createdAt: string
  ownerName: string
  ownerEmail: string
}

export function AdminBusinessesPage() {
  const [businesses, setBusinesses] = useState<BusinessItem[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('/api/admin/businesses')
      .then(res => res.json())
      .then((json: any) => {
        if (json.success) setBusinesses(json.data)
        setLoading(false)
      })
  }, [])

  if (loading) return <div className="text-slate-500">Loading businesses...</div>

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-100">Businesses & Tenants</h1>
        <p className="text-sm text-slate-400 mt-1">Overview of all businesses registered on the platform.</p>
      </div>

      <div className="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden">
        <table className="w-full text-left text-sm">
          <thead className="bg-slate-800/50 text-slate-400 border-b border-slate-800">
            <tr>
              <th className="px-6 py-3 font-medium">Business Name</th>
              <th className="px-6 py-3 font-medium">Owner</th>
              <th className="px-6 py-3 font-medium">Stage</th>
              <th className="px-6 py-3 font-medium">Created</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800">
            {businesses.map(b => (
              <tr key={b.id} className="hover:bg-slate-800/20 transition-colors">
                <td className="px-6 py-4 font-medium text-slate-200">
                  {b.name}
                  <div className="text-xs text-slate-500 font-normal">{b.businessType || 'Unspecified'}</div>
                </td>
                <td className="px-6 py-4">
                  <div className="text-slate-300">{b.ownerName}</div>
                  <div className="text-xs text-slate-500">{b.ownerEmail}</div>
                </td>
                <td className="px-6 py-4">
                  <span className="px-2 py-1 rounded bg-slate-800 text-slate-400 text-xs font-bold uppercase">
                    {b.stage}
                  </span>
                </td>
                <td className="px-6 py-4 text-slate-500">{new Date(b.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
            {businesses.length === 0 && (
              <tr>
                <td colSpan={4} className="px-6 py-8 text-center text-slate-500">No businesses found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
